import { render, staticRenderFns } from "./IncompleteGame.vue?vue&type=template&id=59a47276&scoped=true&"
import script from "./IncompleteGame.vue?vue&type=script&lang=js&"
export * from "./IncompleteGame.vue?vue&type=script&lang=js&"
import style0 from "./IncompleteGame.vue?vue&type=style&index=0&id=59a47276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a47276",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/is_minesweeper-flags-client_main/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
